// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"821eefd3","97":"a5fd10f7","355":"048e4a00","457":"68ada26f","525":"4acd1ac9","555":"aae21f9a","585":"58027670","605":"c257803a","801":"137c0872","955":"96a8cb8e"}[chunkId] + ".chunk.js";
};